export default {
	getSwipeProfiles() {
		return Vue.http.get(`api/swipe-profiles`)
	},

	interactSwipe(payload) {
		return Vue.http.post(`/api/store-swipe`, payload)
	}
}